<template>
  <section class="about-us-tools relative locked text-left">
    <div class="page-container">
      <h2 class="about-us-tools__title mb5">
        Tools for every stage of&nbsp;your
        <br />
        sales career
      </h2>
      <div class="about-us-tools__subtitle">
        Whether you&rsquo;re an&nbsp;SDR trying to&nbsp;get promoted to&nbsp;AE, or&nbsp;a&nbsp;seasoned&nbsp;VP
        of&nbsp;Sales needing an&nbsp;executive network to support you, Bravado offers resources to&nbsp;help sales
        professionals be&nbsp;successful. Level up&nbsp;your career, earn more, and find your dream job.
      </div>
      <div class="about-us-tools__cards flex flex-column justify-center">
        <BravadoCard v-for="item in sales" :key="item.color + item.title" :size="42" :item="item" />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';
import BravadoCard from '../../ui/BravadoItemCard.vue';
import { sales } from '../constants';

export default Vue.extend({
  name: 'AboutUsTools',
  components: { BravadoCard },
  data() {
    return {
      sales,
    };
  },
});
</script>

<style lang="scss" scoped>
.about-us-tools {
  z-index: 1;
  padding: 52px 0 0;

  @include mq('md') {
    text-align: center;
    padding: 60px 0;
  }

  &__title {
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.5px;
    color: var(--white);

    @include mq('md') {
      font-size: 49px;
      line-height: 60px;
      letter-spacing: -1.45366px;
      margin-bottom: 26px;
    }
  }

  &__subtitle {
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: var(--gray-20);
    max-width: 850px;
    margin: 0 auto;

    @include mq('md') {
      font-size: 20px;
      line-height: 32px;
    }
  }

  &__cards {
    gap: 14px;
    padding: 50px 25px 20px;

    @include mq('md') {
      flex-direction: row;
      gap: 28px;
      padding: 95px 0 70px;
    }
  }
}
</style>
